import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import LoadingSpinner from '../../../Shared/LoadingSpinner/LoadingSpinner';
import { useUserStore } from '../../../../context/UserStore';
import EditDailyCoaching from './DailyCoaching/EditDailyCoaching';
import EditObservation from './Observation/EditObservation';
import EditDevelopmentDialogue from './DevelopmentDialogue/EditDevelopmentDialogue';
import EditObservationRss from './ObservationRss/EditObservationRss';

// Each conversation type stores a completely different set of columns, so each needs its
// own form. The type comes from the record itself, never from the :mentorType URL segment:
// that segment is built from mentor_type_name and carries legacy values ("frequent
// feedback") and hardcoded ones ("coaching" from the Record of Interactions button).
const FORMS_BY_TYPE_ID = {
    0: EditDailyCoaching,
    1: EditObservation,
    2: EditDevelopmentDialogue,
    3: EditObservationRss,
};

export default function ViewMentor() {
    const { employeeId, mentorId } = useParams();
    const [employee, setEmployee] = useState(null);
    const [mentor, setMentor] = useState(null);
    const [loadError, setLoadError] = useState(null);
    const user = useUserStore((state) => state.user);

    const loadMentor = async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/api/v1/users/employees/${employeeId}/mentors/${mentorId}`, {
                method: 'get',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user.token}`,
                },
                type: 'json'
            });
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const data = await response.json();
            setEmployee(data.employee.data);
            setMentor(data.mentor.data);
        } catch (error) {
            console.log(error);
            setLoadError('This conversation could not be loaded.');
        }
    };

    useEffect(() => {
        loadMentor();
    }, [employeeId, mentorId]);

    if (loadError) {
        return <p className='text-lg m-5'>{loadError}</p>;
    }

    if (employee === null || mentor === null) {
        return <LoadingSpinner />;
    }

    const EditForm = FORMS_BY_TYPE_ID[mentor.attributes.mentor_type_id];

    if (EditForm === undefined) {
        return (
            <p className='text-lg m-5'>
                This conversation has an unrecognised type
                ({`${mentor.attributes.mentor_type_name}`}) and cannot be displayed.
            </p>
        );
    }

    return <EditForm employee={employee} mentor={mentor} onSaved={loadMentor} />;
}
